// -- Custom jQuery function to get a cached version of a script
var getCachedScript = function(url, options) {
  // Allow user to set any option except for dataType, cache, and url
  options = $.extend( options || {}, {
    dataType: "script",
    cache: true,
    url: url
  });

  // Use $.ajax() since it is more flexible than $.getScript
  // Return the jqXHR object so we can chain callbacks
  return jQuery.ajax( options );
};

// -- Get URL Parameter function
function getURLParameter(sParam) {
  var sPageURL = window.location.search.substring(1);
  var sURLVariables = sPageURL.split('&');

  for (var i = 0; i < sURLVariables.length; i++) {
    var sParameterName = sURLVariables[i].split('=');
    if (sParameterName[0] == sParam) {
      sParameterName[1] = sParameterName[1].replace('+',' ');
      return decodeURIComponent(sParameterName[1]);
    }
  }
}


// -- Google Conversion
function cmg_google_conversion(sDoGoogleConversion, iConversionId, sImageHtml) {
  //set this to FALSE to skip all of the code in this function (instead of deleting the actual code sample)
  var bDoGoogleConversion = false;
  if (sDoGoogleConversion == 'On') { bDoGoogleConversion = true; }

  if (bDoGoogleConversion) {
    var google_conversion_id = iConversionId;
    var google_custom_params = window.google_tag_params;
    var google_remarketing_only = true;

    //inject the 1 pixel image onto the page, thus calling the Google tracking
    $('body').append(sImageHtml);
  }

  return true;
}

/**
 * Google reCaptcha
 */
var recaptchas = function() {
  $(function(){
    $('[data-recaptcha]').each(function(){
      var $this = $(this);

      grecaptcha.render($(this).get(0), {
        sitekey: config.captchaKey,
        callback: function(response) {
          if (response) {
            $this.parents('form').submit();
            $this.after('<button type="submit" class="' + $this.attr('class') + '">' + $this.text() + '</button>').remove();
          }
        }
      });
    });
  });
};

$(window).on('load', function() {
  setTimeout(function() {
    getCachedScript('//www.google.com/recaptcha/api.js?render=explicit');
  }, 1200);

  var recaptchaLibraryLoaded = setInterval(function(){
    if (typeof grecaptcha != 'undefined' && typeof grecaptcha.render != 'undefined') {
      clearInterval(recaptchaLibraryLoaded);
      recaptchas();
    }
  }, 1000);
});


/**
 * Defer loading css styles until after page load
 */
var loadDeferredStyles = function() {
  var addStylesNode = document.getElementById("deferred-styles");
  if (addStylesNode != null) {
    var replacement = document.createElement("div");
    replacement.innerHTML = addStylesNode.textContent;
    document.body.appendChild(replacement);
    addStylesNode.parentElement.removeChild(addStylesNode);
  }
};

var raf = window.requestAnimationFrame || window.mozRequestAnimationFrame ||
    window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;

if (raf) raf(function() { window.setTimeout(loadDeferredStyles, 0); });
else window.addEventListener('load', loadDeferredStyles);


var htmlOverflow = function(element) {
  if (element.is(':visible')) {
    $('html').css('overflow','hidden');
  }
  else {
    $('html').css('overflow','');
  }
};


// -- Used for IE to replace btoa function
function encode64(input) {
  var keyStr = "ABCDEFGHIJKLMNOP" +
    "QRSTUVWXYZabcdef" +
    "ghijklmnopqrstuv" +
    "wxyz0123456789+/" +
    "=";
  input = escape(input);
  var output = "";
  var chr1, chr2, chr3 = "";
  var enc1, enc2, enc3, enc4 = "";
  var i = 0;

  do {
    chr1 = input.charCodeAt(i++);
    chr2 = input.charCodeAt(i++);
    chr3 = input.charCodeAt(i++);

    enc1 = chr1 >> 2;
    enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
    enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
    enc4 = chr3 & 63;

    if (isNaN(chr2)) {
       enc3 = enc4 = 64;
    } else if (isNaN(chr3)) {
       enc4 = 64;
    }

    output = output +
      keyStr.charAt(enc1) +
      keyStr.charAt(enc2) +
      keyStr.charAt(enc3) +
      keyStr.charAt(enc4);
    chr1 = chr2 = chr3 = "";
    enc1 = enc2 = enc3 = enc4 = "";
  } while (i < input.length);

  return output;
}


function alertMessage($type, $message) {
  var $alert = $('#alert');
  if ($alert.length) {
    $alert.addClass('alert--' + $type).text($message).slideDown();
    setTimeout(function() {
      $alert.slideUp(function() {
        $alert.removeClass('alert--' + $type).text('');
      });
    }, 3000);
  }
}


function scriptLoader(deferredScripts) {
  if (deferredScripts && typeof $ != 'undefined') {
    if (deferredScripts.head && Array.isArray(deferredScripts.head) && deferredScripts.head.length) {
      $('head').append(deferredScripts.head.join(''));
    }

    if (deferredScripts.body && Array.isArray(deferredScripts.body) && deferredScripts.body.length) {
      deferredScripts.body.forEach(function(script){
        $('body').prepend(deferredScripts.body.join(''));
      });
    }

    if (deferredScripts.footer && Array.isArray(deferredScripts.footer) && deferredScripts.footer.length) {
      deferredScripts.footer.forEach(function(script){
        $('body').append(deferredScripts.footer.join(''));
      });
    }
  }
}

function ucwords (str) {
  return (str + '').replace(/^([a-z])|\s+([a-z])/g, function ($1) {
    return $1.toUpperCase();
  });
}

format_state = function(input, format) {
  if (typeof input != 'string') { return false; }

  var value;
  var states = [
    ['Arizona', 'AZ'],
    ['Alabama', 'AL'],
    ['Alaska', 'AK'],
    ['Arizona', 'AZ'],
    ['Arkansas', 'AR'],
    ['California', 'CA'],
    ['Colorado', 'CO'],
    ['Connecticut', 'CT'],
    ['Delaware', 'DE'],
    ['Florida', 'FL'],
    ['Georgia', 'GA'],
    ['Hawaii', 'HI'],
    ['Idaho', 'ID'],
    ['Illinois', 'IL'],
    ['Indiana', 'IN'],
    ['Iowa', 'IA'],
    ['Kansas', 'KS'],
    ['Kentucky', 'KY'],
    ['Kentucky', 'KY'],
    ['Louisiana', 'LA'],
    ['Maine', 'ME'],
    ['Maryland', 'MD'],
    ['Massachusetts', 'MA'],
    ['Michigan', 'MI'],
    ['Minnesota', 'MN'],
    ['Mississippi', 'MS'],
    ['Missouri', 'MO'],
    ['Montana', 'MT'],
    ['Nebraska', 'NE'],
    ['Nevada', 'NV'],
    ['New Hampshire', 'NH'],
    ['New Jersey', 'NJ'],
    ['New Mexico', 'NM'],
    ['New York', 'NY'],
    ['North Carolina', 'NC'],
    ['North Dakota', 'ND'],
    ['Ohio', 'OH'],
    ['Oklahoma', 'OK'],
    ['Oregon', 'OR'],
    ['Pennsylvania', 'PA'],
    ['Rhode Island', 'RI'],
    ['South Carolina', 'SC'],
    ['South Dakota', 'SD'],
    ['Tennessee', 'TN'],
    ['Texas', 'TX'],
    ['Utah', 'UT'],
    ['Vermont', 'VT'],
    ['Virginia', 'VA'],
    ['Washington', 'WA'],
    ['West Virginia', 'WV'],
    ['Wisconsin', 'WI'],
    ['Wyoming', 'WY'],
  ];

  var state = ucwords(input);

  $.each(states, function(index, array) {
    var name = array[0];
    var abbr = array[1];

    // Check if input matches a State NAME
    if (state === name) {
      value = (format === 'abbr') ? abbr : name;
    }
    // Check if input matches a State ABBREVIATION
    else if (input.toUpperCase() === abbr) {
      value = (format === 'abbr') ? abbr : name;
    }
  });

  return value ? value : false;
};


function fetchHeader(url, wch) {
  try {
    var req=new XMLHttpRequest();
    req.open("HEAD", url, false);
    req.send(null);
    if(req.status== 200){
        return req.getResponseHeader(wch);
    }
    else return false;
  } catch(er) {
    return er.message;
  }
}

(function($) {
  'use strict';

  if ($('html').hasClass('page-employment')) {

    var apply = {
      domCache: function() {
        // -- Form
        this.$file            = $('#file');
        this.$fileName      = $('#file-name-preview');
        this.$fileToggle     = $('#file-toggle');
        this.$applyForm      = $('#apply-form');

        // -- Job Single View
        this.$applyFormWrap = $('#apply-form-wrap');
        this.$showApplyForm = $('#show-apply-form');
      },

      file: function() {
        var self = this;

        this.$file.change(function(){
          var filename = $(this).val().split(/(\\|\/)/g).pop();
          self.$fileName.html(filename).slideDown(100);
        });

        this.$fileToggle.click(function(e){
          e.preventDefault();
          self.$file.trigger('click');
        });
      },

      applyForm: function() {
        var self = this;

        this.$applyForm.formulate({
          require: 'First Name, Last Name, Email{email}, Resume',
          errorClass: 'error',
          errorParent: true,
          errorLabel: false,
          showOnSubmit: '',
          ajax: false,
          hideFormOnSubmit: false,
          fireOnError: function() {
            $(document).find('.form__field--error').siblings('[data-infield-label]').addClass('form__label--error');
            if (self.$file.hasClass('form__field--error')) {
              $('.form__row--file').addClass('form__row--error');
            } else {
              $('.form__row--file').removeClass('form__row--error');
            }
          }
        });
      },

      toggleForm: function() {
        var self = this;
        this.$showApplyForm.click(function(e){
          e.preventDefault();
          self.$applyFormWrap.slideToggle(200);
        });
      },

      init: function() {
        this.domCache();
        this.file();
        this.applyForm();
        this.toggleForm();
      }
    };

    $(function() {
      apply.init();
    });

  }

})(jQuery);

// -- Used for google maps
if (typeof filteredPropertyIds == 'undefined') {
  var filteredPropertyIds;
}

(function($) {
  'use strict';

  if ($('html').hasClass('page-communities')) {

    var communities = {
      dom: function() {
        this.$header = $('#header');
        this.$headerDummy = $('#headerDummy');

        this.$listing   = $('#property-listing');
        this.$listItem  = $('.js-marker');
        this.$noResults = $('#property-no-results');

        this.$stateContent = $('#property-state-content');

        this.$filterForm     = $('#property-filter-form');
        this.$filterLoading  = $('#property-filter-loading');
        this.$filterSelect   = $('[data-js-hook="property-filter-select"]');
        this.$filterInput    = $('#property-filter-input');
        this.$filterClear    = $('#property-filter-clear');
        this.$filterClearAll = $('#property-filter-clear-all');
        this.$filterToggle   = $('#property-filter-toggle');

        this.$citySelect = $('select[name="city"]');

        this.$moreFilters   = $('#more-filters');
        this.$hiddenFilters = $('[data-js-hook="hidden-filter-row"]');
      },

      definitions: function() {
        this.cacheData    = mapSettings.cacheData;
        this.filterData   = mapSettings.cacheData.filters;
        this.propertyData = mapSettings.cacheData.properties;
        this.rootPath     = '/' + window.location.pathname.replace(/^\/|\/$/g, '').split('/')[0] + '/';
        this.rangeFilters = ['rent_min', 'rent_max', 'sq_ft_min', 'sq_ft_max'];
        this.queryFields  = ['name','state','city'];
      },

      header: function() {
        var self = this;

        $(window).on('load resize', function() {
          self.$headerDummy.height(self.$header.outerHeight());
          $('.find-your-home__header').height(self.$header.outerHeight());
        });
      },

      filterActions: function() {
        var self = this;
        var timeout;
        var urlState;
        var toggleText = this.$filterToggle.text();
        var aUrlState = window.location.pathname.replace(/^\/|\/$/g, '').split('/');

        if (aUrlState.length > 1) {
          urlState = aUrlState[1].replace('-', ' ');
        }

        // -- Filter after page load (used for url param filtering)
        $(window).on('load', function() {
          if ((urlState && format_state(urlState, 'abbr').length == 2) || format_state(getURLParameter('state'), 'abbr').length == 2) {
            self.$filterForm.submit();
          }
          else {
            self.$listItem.fadeIn();
          }
        });

        // -- Filter after history back/forward
        window.onpopstate = function() {
          aUrlState = window.location.pathname.replace(/^\/|\/$/g, '').split('/');
          if (aUrlState.length > 1) {
            $('select[name="state"]').val(format_state(aUrlState[1].replace('-', ' '), 'abbr'));
          }
          else {
            $('select[name="state"]').val('');
          }
          self.$filterForm.submit();
        };

        // -- Filter Toggle Mobile
        this.$filterToggle.click(function(e){
          e.preventDefault();
          $(this).text(toggleText = $(this).text() == $(this).data('close') ? $(this).data('open') : $(this).data('close'));
          self.$filterForm.slideToggle(200);
        });

        // -- On filter select change
        this.$filterSelect.change(function() {
          var pageTitle = config.page_title;
          var pageDescription = config.page_description;

          // -- Change city options if state changed
          if ($(this).attr('name') == 'state') {
            var selectedCity = '';
            var aCityOptions = '<option value="">Any City</option>';
            var stateValue = $(this).val();
            var loadPath = self.rootPath;

            // -- Keep selected city
            if (self.$citySelect.val()) {
              selectedCity = self.$citySelect.val();
            }

            if (stateValue) {
              $.each(self.cacheData.filters.city.options[stateValue], function(value, city) {
                aCityOptions += '<option value="'+value+'"'+(selectedCity == city ? ' selected' : '')+'>'+city+'</option>';
              });
              self.$citySelect.html(aCityOptions);
              var statePath = format_state(stateValue).toLowerCase().replace(' ', '-');
              loadPath += statePath + '/';

              // -- Change meta title
              if (mapSettings.states[stateValue].meta_title.length) {
                pageTitle = mapSettings.states[stateValue].meta_title;
                pageTitle = pageTitle.replace('{COMPANY_NAME}', config.company);
              }
              else {
                pageTitle = format_state(stateValue) + ' ' + config.page_title;
              }
              // -- Change meta description
              if (mapSettings.states[stateValue].meta_description.length) {
                pageDescription = mapSettings.states[stateValue].meta_description;
                pageDescription = pageDescription.replace('{COMPANY_NAME}', config.company);
              }
              else {
                pageDescription = format_state(stateValue) + ' ' + config.page_description;
              }
            }
            else {
              var cities = [];
              $.each(self.cacheData.filters.city, function(i, states) {
                if (i == 'options') {
                  $.each(states, function(i, state) {
                    $.each(state, function(value, city) {
                      cities.push(city);
                    });
                  });
                }
              });

              console.log(cities.sort());

              $.each(cities, function(i, city) {
                aCityOptions += '<option value="'+city+'"'+(selectedCity == city ? ' selected' : '')+'>'+city+'</option>';
              });

              self.$citySelect.html(aCityOptions);
            }
            document.title = pageTitle;
            $('meta[name=description]').attr('content', pageDescription);
            window.history.pushState(null, null, loadPath);
          }

          self.$filterForm.submit();
        });

        // -- Filter While Typing
        this.$filterInput.on('input', function(){
          var val = $(this).val().trim();

          if (val === '') {
            self.$filterForm.submit();
            self.$filterClear.hide();
            self.$filterInput.removeClass('filter__field--has-value');
          } else {
            self.$filterClear.show();
            self.$filterInput.addClass('filter__field--has-value');
            clearTimeout(timeout);
            timeout = setTimeout(function(){
              self.$filterLoading.fadeIn(200);
              self.$filterForm.submit();
            }, 600);
          }
        });

        // -- Filter Clear
        this.$filterClear.click(function(e){
          e.preventDefault();
          self.$filterClear.hide();
          self.$filterInput.val('');
          self.$filterForm.submit();
        });

        // -- Clear all filters
        this.$filterClearAll.click(function(e){
          e.preventDefault();
          $('.community__listing-item').removeClass('active');
          self.$filterInput.val('');
          self.$filterClear.hide();
          self.$filterSelect.each(function(select){
            if ($(self.$filterSelect[select]).attr('name') != 'state') {
              $(self.$filterSelect[select]).val('');
            }
          });
          self.$filterForm.submit();
        });

        // -- On form submit
        this.$filterForm.on('submit', function(e) {
          e.preventDefault();
          var values = false;
          var loadPath = self.rootPath;
          var stateValue = $(this).val();
          var stateData;

          $(this).data('complete', false);

          self.$filterLoading.fadeIn(200);

          if (self.$filterInput.val() !== '') {
            values = true;
          }

          self.$filterSelect.each(function(index){
            if ($(self.$filterSelect[index]).val() != null && $(self.$filterSelect[index]).val().length > 0) {
              values = true;
            }
            if ($(this).attr('name') == 'state') {
              var stateValue = $(this).val();
              if (stateValue) {
                var statePath = stateValue ? format_state(stateValue).toLowerCase().replace(' ', '-') : false;
                loadPath += statePath + '/';
                stateData = {state: format_state(stateValue).toLowerCase()};
              }
              else {
                stateData = false;
              }
            }
          });

          if (values) {
            self.$filterClearAll.fadeIn(200);
          }
          else {
            self.$filterClearAll.fadeOut(200);
          }

          $('.community__listing-item').removeClass('active');

          self.filterData = $(this).serializeArray();
          self.filterProperties(self.filterData);

          // not needed for individual state pages
          // if (!stateData) {
          //   self.$stateContent.slideUp();
          // }

          // self.$stateContent.load(self.rootPath, stateData, function(response, status, xhr) {
          //   if (status == 'error') {
          //     console.log(xhr.statusText);
          //   }
          //   else {
          //     self.$stateContent.slideDown();
          //   }
          // });
        });
      },

      filterProperties: function(filterData) {
        var self = this;
        var filters = [];
        var properties = self.propertyData;

        filteredPropertyIds = [];

        // -- Get list of filters that user has supplied values for
        $.each(filterData, function(i, filter) {
          if (filter.value.length) {
            filters.push(filter);
          }
        });

        // -- No filters? Then show everything.
        if (!filters.length) {
          $.each(properties, function(property_id) {
            filteredPropertyIds.push(property_id);
          });

          this.$noResults.hide();
          this.$listing.show();
          this.$listItem.show();
          self.setFilterComplete();

          return true;
        }

        filteredPropertyIds = [];
        this.$listItem.hide();

        // -- Loop through each property
        $.each(properties, function(property_id, property_values) {
          var showProperty = true;

          // -- Loop through every filter - if any of them DON'T match, then this property is excluded and not displayed
          $.each(filters, function(i, filter) {
            //-- Text inputs
            if (filter.name === 'query' && self.filterQuery(filter.value, property_values) == false) {
              showProperty = false;
              return false; //stop processing the rest of the filters
            }

            if ($.inArray(filter.name, self.rangeFilters) >= 0 && self.filterRange(filter.name, filter.value, property_values) == false) {
              showProperty = false;
              return false; //stop processing the rest of the filters
            }

            //-- Anything besides text inputs
            if (filter.name !== 'query' && $.inArray(filter.name, self.rangeFilters) < 0 && self.filterExact(filter.name, filter.value, property_values) == false) {
              showProperty = false;
              return false; //stop processing the rest of the filters
            }
          });

          if (showProperty) {
            filteredPropertyIds.push(property_id);
            self.$listItem.filter('[data-id="' + property_id + '"]').show();
          }
        });

        // -- Check to make sure that there is a valid property
        if (typeof filteredPropertyIds != 'undefined' && filteredPropertyIds.length) {
          this.$listing.show();
          this.$noResults.hide();
        }
        // -- If not show "no results" div
        else {
          this.$listItem.show();
          this.$listing.hide();
          this.$noResults.show();
        }

        self.setFilterComplete();
      },

      setFilterComplete: function() {
       var self = this;
        self.$filterForm.data('complete', true);
        setTimeout(function(){
          self.$filterLoading.fadeOut(200);
        }, 500);
      },

      filterQuery: function(value, property_values) {
        var self = this;
        var newValue = value.toLowerCase();
        var match = false;

        $.each(self.queryFields, function(key, field) {
          if (match = String(property_values[field]).toLowerCase().indexOf(newValue) != -1) {
            return false;
          }
        });

        return match;
      },

      filterRange: function(key, value, property_values) {
        var match = false;
        var field = key.substr(0, key.indexOf('_m'));
        var min = field + '_min';
        var max = field + '_max';

        if ( key == min ) {
          if ( (property_values[min] && value <= property_values[min]) || (property_values[max] && value <= property_values[max]) ) {
            return true;
          }
        }
        else if ( key == max ) {
          if (property_values[min] && value >= property_values[min]) {
            return true;
          }
        }

        return match;
      },

      filterExact: function(key, value, property_values) {
        var match = false;

        if ($.isArray(property_values[key])) {
          if (match = $.inArray(value, property_values[key]) >= 0) {
            return true;
          }
        }
        else if (key === 'state') {
          if (match = format_state(value) === format_state(property_values[key])) {
            return true;
          }
        }
        else if (match = value == property_values[key]) {
          return true;
        }

        return match;
      },

      pageActions: function() {
        var self = this;

        // -- Expand Filters
        this.$moreFilters.click(function(e){
          e.preventDefault();
          self.$hiddenFilters.slideToggle(200);
        });
      },

      ready: function() {
        this.dom();
        this.definitions();
        this.header();
        this.filterActions();
        this.pageActions();
      }
    };

    $(function() { communities.ready(); });
  }

})(jQuery);

(function($) {
  'use strict';

  if ($('html').hasClass('page-community')) {

    var community = {
      dom: function() {
        this.$tab            = $('[data-js-hook="tab"]');
        this.$container      = $('#gallery-container');
        this.$loading        = $('#loading');
        this.$openCategories = $('[data-js-hook="open-categories"]');
        this.$tabWrap        = $('#tab-wrap');
      },

      tab: function() {
        var self = this;

        this.$tab.click(function(e){
          e.preventDefault();
          var $this = $(this);
          var action = $(this).data('action');
          var showLoader = setTimeout(function(){
            self.$loading.fadeIn(200);
          }, 500);

          self.$container.load(action, {category: $(this).data('category')}, function(){
            clearTimeout(showLoader);
            self.$loading.fadeOut(200);
            self.$tab.removeClass('community-details__gallery-tab--active');
            $this.addClass('community-details__gallery-tab--active');
            self.$openCategories.text($this.text());
            // self.swipebox();

            if ($(window).width() <= 808) {
              self.$tabWrap.slideUp(100);
            }

            $('[data-src]').lazyload();
          });
        });

        this.$openCategories.click(function(e){
          e.preventDefault();
          self.$tabWrap.slideToggle(100);
        });
      },

      ready: function() {
        this.dom();
        this.tab();
      }
    };

    $(function() { community.ready(); });

  }

})(jQuery);

/* -----------------------------------------------------------------
  CONFIG ELEMENT HELPER
----------------------------------------------------------------- */
function _e(selector) {
  return new jonahConfig.element._instance(selector);
}

/* -----------------------------------------------------------------
  CONFIG OBJECT
----------------------------------------------------------------- */
var jonahConfig = {
  siteUrl: config.siteUrl,
  mobileBreak: 808
};

/* -----------------------------------------------------------------
  CONFIG WOW OBJECT
  Remove when migrating jonahConfig object to site not using WOW for
  animations.
----------------------------------------------------------------- */
if (typeof WOW == 'function') {
  jonahConfig.wowInit = function() {
    jonahConfig.wow = new WOW();
    jonahConfig.wow.destroy = function() {
      $('.wow').removeClass('wow');
    }
  }();
}

/* -----------------------------------------------------------------
  CONFIG REQUEST OBJECT
----------------------------------------------------------------- */
jonahConfig.request = {
  _cache: [],

  _request: function(type, url, dataOrCallback, callback, dataType) {

    if (dataOrCallback instanceof Object || typeof dataOrCallback == 'string') {
      var data = dataOrCallback;
    } else {
      var data = false;
      console.log(dataOrCallback);
      callback = dataOrCallback;
    }

    var cacheIndex = data ? type + ':' + url + '?' + $.param(data) : type + ':' + url;
    var cache = this._cache[cacheIndex];

    if (cache) {
      callback(cache, {fromCache: true, cacheIndex: cacheIndex});
    } else {
      $.ajax({
        type: type,
        url: url,
        data: data,
        success: function(data) {
          jonahConfig.request._cache[cacheIndex] = data;
          callback(data, {fromCache: false, cacheIndex: cacheIndex});
        },
        dataType: dataType,
        cache: false
      });
    }
  },

  post: function(url, dataOrCallback, callback, dataType) {
    this._request("POST", url, dataOrCallback, function(data, cached){
      callback(data, cached);
    }, dataType);
  },

  get: function(url, dataOrCallback, callback, dataType) {
    this._request("GET", url, dataOrCallback, function(data, cached){
      callback(data, cached);
    }, dataType);
  },

  load: function(element, url, dataOrCallback, callback, dataType, type) {
    type = type || "GET";
    _e(element).ready(function($element){
      jonahConfig.request._request(type, url, dataOrCallback, function(data, cached){
        $element.html(data);
        callback(data, cached);
      }, dataType);
    }, 300);
  },
};

/* -----------------------------------------------------------------
  CONFIG ELEMENT
----------------------------------------------------------------- */
jonahConfig.element = {
  _instances:  {},

  _instance: function(selector) {
    var self = this;
    this.sliding = false;

    if (selector instanceof jQuery) {
      this.selector = selector;
    } else {
      this.selector = $(selector);
    }

    this.ready = function(callback, timeout) {
      $(function(){
        var interval;
        var loop = 0;
        interval = setInterval(function(){
          ++loop;
          if (self.selector.length || (timeout && loop == timeout)) {
            if (self.selector.length) {
              callback(self.selector);
            }
            clearInterval(interval);
          }
        }, 50);
      });
    }

    this.load = function(url, dataOrCallback, callback, dataType, type) {
      jonahConfig.request.load(self.selector, url, dataOrCallback, function(data, cached){
        callback(data, cached);
      }, dataType, type);
    }

    this.toggleText = function(object){
      self.ready(function($element){
        $element.text(object.onCondition ? object[1] : object[0]);
      });
    }

    this.centerScreenOn = function(scrollSpeed){
      scrollSpeed = scrollSpeed || 200;
      self.ready(function($element){
        $('html, body').animate({
          scrollTop: $element.offset().top - $(window).height()/2 + $element.outerHeight()/2
        }, scrollSpeed);
      });
    }

    this.slideFadeDown = function(speed, callback) {
      speed = speed || 200;
      self.ready(function($element){
        if (!$element.is(':visible')) {
          $element
            .css('opacity', 0)
            .slideDown(speed)
            .animate({ opacity: 1 }, {
              queue: false,
              duration: speed,
              complete: callback
            });
        }
      });
    }

    this.slideFadeUp = function(speed, callback) {
      speed = speed || 200;
      self.ready(function($element){
        if ($element.is(':visible')) {
          $element
            .css('opacity', 1)
            .slideUp(speed)
            .animate({ opacity: 0 }, {
              queue: false,
              duration: speed,
              complete: callback
            });
          }
      });
    }

    this.slideFadeToggle = function(speed, callback) {
      self.ready(function($element){
        if (!self.sliding) {
          self.sliding = true;
          if ($element.is(':visible')) {
            self.slideFadeUp(speed, function(){
              self.sliding = false;
              if (callback) {
                callback();
              }
            });
          } else {
            self.slideFadeDown(speed, function(){
              self.sliding = false;
              if (callback) {
                callback();
              }
            });
          }
        }
      });
    }
  }
}

/* -----------------------------------------------------------------
  CONFIG LOCATION OBJECT
----------------------------------------------------------------- */
jonahConfig.location = {
  current: window.location.pathname.substr(1) ? window.location.pathname.substr(1).replace(/\/$/, '') : 'index',
  root: window.location.pathname.split('/')[1],
  queryString: window.location.search,

  isRoot: function(root) {
    return root.replace(/(\/$|^\/)/g, '') === this.root;
  },

  isPage: function(current) {
    return current.replace(/(\/$|^\/)/g, '') === this.current;
  },

  getQueryString: function(string) {
    if (!window.location.search) {
      return false;
    }

    if (string) {
      var query = this.queryString;
    } else {
      var query = [];
      this.queryString.replace(/(^\?)/, '').split('&').forEach(function(param){
        param = param.split('=');
        query[decodeURIComponent(param[0])] = decodeURIComponent(param[1]);
      });
    }
    return query;
  },

  getParam: function(param) {
    var queries = this.getQueryString();
    param = param.trim();
    return (param && queries && queries[param]) ? queries[param] : false;
  }
};

/* -----------------------------------------------------------------
  CONFIG SCREEN OBJECT
----------------------------------------------------------------- */
jonahConfig.screen = {
  _resizeCallbacks: [],
  _resize: function() {
    $(window).on('load resize', function(){
      var windowWidth = $(window).width();
      jonahConfig.screen.size = windowWidth;
      if (jonahConfig.screen._resizeCallbacks.length) {
        jonahConfig.screen._resizeCallbacks.forEach(function(callback){
          callback(windowWidth);
        });
      }
    });
  }(),

  /*
    @var size | Int
    Current width of window. Adjusts as browser resizes.
  */
  size: $(window).width(),

  /*
    @method onResize
    @param callback | Function(windowWidth)

    Define a function to perform on window resize.
  */
  onResize: function(callback) {
    jonahConfig.screen._resizeCallbacks.push(callback);
  },

  /*
    @method atSize
    @param size | Int
    @param callback | Function

    Define a function to perform when the window size is exactly
    the size passed to the first position.
  */
  atSize: function(size, callback) {
    jonahConfig.screen.onResize(function(windowWidth){
      if (windowWidth === size) {
        callback(windowWidth);
      }
    });
  },

  /*
    @method whenSmallerThan
    @param size | Int
    @param callback | Function

    Define a function to perform ONCE when the window size becomes
    smaller than the size passed to the first position.
  */
  whenSmallerThan: function(size, callback) {
    var callbackFired = false;
    jonahConfig.screen.onResize(function(windowWidth){
      if (windowWidth < size) {
        if (!callbackFired) {
          callback(windowWidth);
          callbackFired = true;
        }
      } else {
        callbackFired = false;
      }
    });
    return this;
  },

  /*
    @method whileSmallerThan
    @param size | Int
    @param callback | Function

    Define a function to perform while the window size is
    smaller than the size passed to the first position.
  */
  whileSmallerThan: function(size, callback) {
    jonahConfig.screen.onResize(function(windowWidth){
      if (windowWidth < size) {
        callback(windowWidth);
      }
    });
    return this;
  },

  /*
    @method whenLargerThan
    @param size | Int
    @param callback | Function

    Define a function to perform ONCE when the window size becomes
    larger than the size passed to the first position.
  */
  whenLargerThan: function(size, callback) {
    var callbackFired = false;
    jonahConfig.screen.onResize(function(windowWidth){
      if (windowWidth > size) {
        if (!callbackFired) {
          callback(windowWidth);
          callbackFired = true;
        }
      } else {
        callbackFired = false;
      }
    });
    return this;
  },

  /*
    @method whileLargerThan
    @param size | Int
    @param callback | Function

    Define a function to perform while the window size is
    larger than the size passed to the first position.
  */
  whileLargerThan: function(size, callback) {
    jonahConfig.screen.onResize(function(windowWidth){
      if (windowWidth > size) {
        callback(windowWidth);
      }
    });
    return this;
  }
};

/* -----------------------------------------------------------------
  CONFIG EMAIL OBJECT
----------------------------------------------------------------- */
jonahConfig.email = {
  elements: $('[data-mail-name]'),

  _convert: function($element) {
    var email = $element.data('mail-name') + '@' + $element.data('mail-host');
    $element.attr('href', 'mailto:' + email);
    if ($element.text() === '') {
      $element.text(email);
    }
    else if ($element.text().indexOf("{") >= 0) {
      var text = $element.html();
      text = text.replace(/{(.*?)}/, email);
      $element.html(text);
    }
    $element.removeAttr('data-mail-name');
    $element.removeAttr('data-mail-host');
  },

  mailToInject: function(el) {
    if (el) {
      jonahConfig.email._convert(el);
    } else {
      jonahConfig.email.elements.each(function(){
        jonahConfig.email._convert($(this));
      });
    }
  }
};

/* -----------------------------------------------------------------
  MAIL TO INJECT INIT
----------------------------------------------------------------- */
jonahConfig.email.mailToInject();

(function($) {
  'use strict';

  var forms = {
    dom: function() {
      // -- Infield Label
      this.$infieldLabels  = $('[data-infield-label]');

      // -- Pick A Date
      this.$datePicker     = $('[data-js-hook="pickadate"]');

      // -- Form Stuff
      this.$formLoader     = $('#form-loading');
      this.$contactForm    = $('#contact-form');
      this.$propertySelect = $('select#property');
    },

    definitions: function() {
      if (typeof properties != 'undefined') {
        this.properties = properties;
        this.defaultProperties = this.$propertySelect.length ? this.$propertySelect.html() : false;
      }
    },

    infieldLabels: function() {
      this.$infieldLabels.each(function() {
        var self = $(this);
        var target = $(this).attr('for');
        var input = $('#'+target);

        input.on('focus', function(){
          if (!$(this).val()) {
            self.addClass('focus');
          }
        });

        input.on('keyup input', function() {
          if ($(this).val()) {
            self.removeClass('focus');
            self.addClass('active');
          }
          else {
            self.removeClass('active');
            self.addClass('focus');
          }
        });

        input.on('blur', function() {
          if (!$(this).val()) {
            self.removeClass('focus');
          }
        });
      });
    },

    pickadate: function() {
      this.$datePicker.pickadate();
    },

    propertySelect: function() {
      if (typeof properties != 'undefined') {
        const self = this;
        const corpOption = $('option[value="corporate"]', self.$propertySelect);

        $('select#state').change(function() {
          var selected = '';
          var selectedProperty = self.$propertySelect.val();
          if ($(this).val().length) {
            var newPropertyOptions = [];
            newPropertyOptions.push('<option value="">Select a Property</option>');
            if (selectedProperty === 'corporate') {
              corpOption.attr('selected', true);
            }
            newPropertyOptions.push(corpOption);
            $.each(self.properties[$(this).val()].properties, function(i, property) {
              selected = selectedProperty == property ? ' selected' : '';
              newPropertyOptions.push('<option value="' + property + '"' + selected + '>' + property + '</option>');
            });
            self.$propertySelect.html(newPropertyOptions);
          }
          else {
            self.$propertySelect.html(self.defaultProperties);
          }
        });
      }
    },

    forms: function() {
      var self = this;

      // -- Validate the form
      this.$contactForm.formulate({
        require: 'First Name, Last Name, Property, Email{email}, Comments',
        errorClass: 'error',
        errorParent: true,
        errorLabel: false,
        showOnSubmit: '#contact-confirm',
        inlineMsg: true,
        inlineMsgClass: 'form__inline-error',
        hideFormOnSubmit: false,
        fireOnSubmit: function() {
          self.$formLoader.fadeIn(200);
        },
        fireOnSuccess: function() {
          self.$formLoader.fadeOut(200);
          cmg_google_conversion($('#contact_us_conversion').val(), $('#contact_us_conversion_id').val(), $('#contact_us_conversion_html').val());
        },
        fireOnError: function(){
          self.$formLoader.fadeOut(200);
          $(document).find('.form__form-field--error').siblings('[data-infield-label]').addClass('form__label--error');
        }
      });
    },

    ready: function() {
      this.dom();
      this.definitions();
      this.infieldLabels();
      this.pickadate();
      this.propertySelect();
      this.forms();
    }
  };

  $(function() { forms.ready(); });

})(jQuery);

(function($) {
  'use strict';

  if ($('html').hasClass('page-home-page')) {

    var index = {
      domCache: function() {
        this.$header       = $('#header');
        this.$hero         = $('#hero');
        this.$video        = $('#homeVideo');
        this.$rotator      = $('#rotator');
        this.$aboutButton  = $('#expand-button');
        this.$aboutBody    = $('#about-hidden');
        this.$searchForm   = $('#index-search-form');
        this.$searchSubmit = $('#index-search-submit');
        this.$searchClear  = $('#index-search-clear');
        this.$searchInput  = $('#index-search-input');
      },

      hero: function() {
        var self = this;
        var width = $(window).width();

        $(window).on('load resize', function(event) {
          if (!self.$hero.hasClass('homepage__hero--default')) {
            var offsetTimeout;
            var offset = self.$header.outerHeight();

            if (event.type == 'load') {
              offsetTimeout = setTimeout(function() {
                self.$hero.height($(window).height() - offset);
              }, 300);
            }
            else if (offsetTimeout) {
              clearTimeout(offsetTimeout);
            }

            if ($(window).width() != width) {
              width = $(window).width();
              self.$hero.height($(window).height() - offset);
            }
          }
        });
      },

      video: function() {
        var self = this;

        if (self.$video.length) {
          var video = self.$video[0];
          var $fallback = $('.homepage__video-fallback');

          // -- Remove video if taking too long to load
          setTimeout(function() {
            if (video.readyState < 3) {
              console.info('Connection too slow. Replacing video with static image');
              $fallback.show();
              video.pause(0);
              video.src = '';
              if (video.childNodes && $(video.childNodes[1]).length > 0) {
                video.childNodes[1].src = '';
              }
              video.load();
              video.childNodes[1].remove();
              self.$video.remove();
            }
          }, 1500);

          Modernizr.on('videoautoplay', function(result) {
            if (!result) {
              if (self.$video.length) {
                if ('playsInline' in document.createElement(self.$video.attr('id'))) {
                  return false;
                }
                else {
                  if (video.play() === undefined) {
                    video.remove();
                    $fallback.show();
                  }
                }
              }
            }
          });
        }
      },

      rotator: function() {
        this.$rotator.addClass('flexslider').flexslider({
          controlNav: true,
          directionNav: false,
          // -- Comment out Controls Container if
          // -- you intend to use controlNav
          controlsContainer: '.flex-direction-nav-container'
        });
      },

      about: function() {
        this.$aboutButton.click(function(e){
          e.preventDefault();
          this.$aboutBody.slideToggle(100);
        });
      },

      indexSearch: function() {
        var self = this;

        this.$searchInput.on('input', function(){
          if ($(this).val() === "") {
            self.$searchClear.hide();
          } else {
            self.$searchClear.show();
          }
        });

        this.$searchSubmit.click(function(e){
          e.preventDefault();
          self.$searchForm.submit();
        });

        this.$searchClear.click(function(e){
          e.preventDefault();
          self.$searchInput.val('');
          self.$searchClear.hide();
        });
      },

      init: function() {
        this.domCache();
        this.hero();
        this.video();
        this.rotator();
        this.about();
        this.indexSearch();
      }
    };

    $(document).ready(index.init());

  }

})(jQuery);

(function($) {
  'use strict';

  var init = {
    domCache: function() {
      // -- Misc
      this.$html     = $('html');
      this.$body     = $('body');
      this.$htmlBody = $('html, body');

      this.$headerDummy = $('#headerDummy');
      this.$headerMain  = $('#headerMain');

      this.$page          = $('#page');
      this.$email         = $('[data-mail-name]');
      this.$petLink       = $('[data-js-hook="pet-policy"]');
      this.$petPolicy     = $('#pet-policy-flyout');

      // -- Mobile Nav
      this.$hamburger = $('#hamburger');
      this.$mobileNav = $('#mobile-nav');

      // -- Sidebar
      this.$sidebarToggle     = $('#sidebar-toggle');
      this.$sidebarToggleText = $('#sidebar-toggle-text');
      this.$sidebarToggleIcon = $('#sidebar-toggle-icon');
      this.$sidebarNav        = $('#sidebar-nav');

      // -- Filter
      this.$filterForm     = $('#filter-form');
      this.$filterLoading  = $('#filter-loading');
      this.$filterSelect   = $('[data-js-hook="filter-select"]');
      this.$filterResults  = $('#filter-results-container');
      this.$filterInput    = $('#filter-input');
      this.$filterClear    = $('#filter-clear');
      this.$filterClearAll = $('#filter-clear-all');
      this.$filterToggle   = $('#filter-toggle');
      this.$clearFilters   = $('#clear-all');

      this.$citySelect = $('select[id="city"]');

      if (this.$citySelect.length) {
        this.cityOptions = this.$citySelect.html();
      }

      // -- Other Shtuff
      this.$lightbox = $('[data-js-hook="swipebox"],[target="popup"]');
      this.$rotator  = $('[data-rotator]');

      this.$findYourHome      = $('[data-js-hook="find-home"]');
      this.$findHome          = $('#findHome');
      this.$findHomeContainer = $('#findHomeContainer');
    },

    mobileNav: function() {
      var self = this;
      this.$hamburger.click(function(e){
        e.preventDefault();
        self.$html.toggleClass('menu-open');
        self.$mobileNav.fadeToggle(200);
      });
    },

    header: function() {
      var self = this;

      $(window).on('load resize', function() {
        let headerHeight = self.$headerMain.outerHeight();
        $('html').get(0).style.setProperty('--jd-header-height', headerHeight + 'px');
        self.$headerDummy.height(headerHeight);
      });
    },

    sidebar: function() {
      var self = this;
      this.$sidebarToggle.click(function(e){
        e.preventDefault();
        self.$sidebarNav.slideToggle(100, function(){
          var sidebarToggleText = self.$sidebarNav.is(':visible') ? 'Hide Menu' : 'Show Menu';
          var sidebarToggleIcon = self.$sidebarNav.is(':visible') ? '-' : '+';
          self.$sidebarToggleText.text(sidebarToggleText);
          self.$sidebarToggleIcon.text(sidebarToggleIcon);
        });
      });
    },

    pagination: function() {
      var self = this;
      // -- Cache DOM here since we re-call self.pagination()
      // -- in `load` callback and need to re-cache nodes.
      this.$pagination = $('#pagination');
      this.$paginationLink = $('#pagination').find('a');
      this.$paginationLink.click(function(e){
        e.preventDefault();
        $(self.$pagination.data('load-in')).load($(this).attr('href'), {}, function(){
          self.$htmlBody.animate({scrollTop: self.$page.offset().top});
          self.pagination();
        });
      });
    },

    filter: function() {
      var self = this;
      var timeout;

      // -- Filter Form Submit
      this.$filterForm.submit(function(e){
        e.preventDefault();
        var values = false;

        self.$filterLoading.fadeIn(200);

        if (self.$filterInput.val() !== '') {
          values = true;
        }

        self.$filterSelect.each(function(select){
          if ($(self.$filterSelect[select]).val() != null && $(self.$filterSelect[select]).val().length) {
            values = true;
          }
        });

        if (values) {
          self.$filterClearAll.fadeIn(200);
        }
        else {
          self.$filterClearAll.fadeOut(200);
        }

        self.$filterForm.data('complete', false);
        self.$filterResults.load($(this).attr('action'), $(this).serialize(), function() {
          self.$filterForm.data('complete', true);
          setTimeout(function(){
            self.$filterLoading.fadeOut(200);
          }, 200);
        });
      });

      // -- Filter Select Change
      this.$filterSelect.change(function() {
        // -- Pre-filter city select based on selected state
        if (self.$citySelect.length) {
          var aCityOptions;
          var selectedCity = '';

          if ($(this).attr('name') == 'state') {
            if (self.$citySelect.val()) {
              selectedCity = self.$citySelect.val();
            }
            if ($(this).val()) {
              var state = $(this).val();
              aCityOptions = '<option value="">Any City</option>';
              $.each(locations[state], function(i, cities) {
                $.each(cities, function(i, city) {
                  aCityOptions += '<option value="'+city+'"'+(selectedCity == city ? ' selected' : '')+'>'+city+'</option>';
                });
              });
              self.$citySelect.html(aCityOptions);
            }
            else {
              self.$citySelect.html(self.cityOptions);
            }
          }
        }

        self.$filterForm.submit();
      });

      // -- Filter While Typing
      this.$filterInput.on('input', function(){
        var val = $(this).val().trim();

        if (val === '') {
          self.$filterForm.submit();
          self.$filterClear.hide();
          self.$filterInput.removeClass('filter__field--has-value');
        } else {
          self.$filterClear.show();
          self.$filterInput.addClass('filter__field--has-value');
          clearTimeout(timeout);
          timeout = setTimeout(function(){
            self.$filterLoading.fadeIn(200);
            self.$filterForm.submit();
          }, 600);
        }
      });

      // -- Filter Clear
      this.$filterClear.click(function(e){
        e.preventDefault();
        self.$filterClear.hide();
        self.$filterInput.val('');
        self.$filterForm.submit();
      });

      this.$filterClearAll.click(function(e){
        e.preventDefault();
        self.$filterInput.val('');
        self.$filterClear.hide();
        self.$filterSelect.each(function(select){
          $(self.$filterSelect[select]).val('');
        });
        self.$filterForm.submit();
      });

      // -- Filter Toggle Mobile
      this.$filterToggle.click(function(e){
        e.preventDefault();
        self.$filterToggle.slideUp(200);
        self.$filterForm.slideDown(200);
      });
    },

    petPolicy: function() {
      var main = this;

      this.$petLink.click(function(e){
        e.preventDefault();
        $(this).toggleClass('background-primary svg-primary');
        main.$petPolicy.fadeToggle();
      });
    },

    lazyLoad: function() {
      if ($('.lazy-load').length) {
        $('.lazy-load').lazyload();
      }
    },

    lightbox: function() {
      this.$lightbox.each(function(index, element) {
        var href = $(this).attr('href');
        // -- Replace YouTube short URL with long
        if (href.indexOf('youtu.be') >= 0) {
          href = href.replace('youtu.be/','www.youtube.com/watch?v=');
          $(this).attr('href', href);
        }
        // -- Add gallery attribute if non exists (this will make sure that one-off popups do NOT get added to another swipebox gallery)
        if (!element.hasAttribute('data-rel') && !element.hasAttribute('rel')) {
          $(this).attr('data-rel','popup' + index);
        }
      });

      this.$lightbox.swipebox({
        hideBarsDelay: false,
        removeBarsOnMobile: false,
        loopAtEnd: true,
        afterOpen: function(){
          // -- Trigger close event on #swipebox-container click event.
          $('#swipebox-container').click(function(e){
            e.preventDefault();
            $('#swipebox-close').trigger('click');
          });
          // -- Wait for image to load after open, then bind click events
          // -- to disable propogation from certain elements.
          var interval;
          interval = setInterval(function(){
            if ($('#swipebox-slider .slide.current img').length) {
              clearInterval(interval);
              $('#swipebox-top-bar, #swipebox-slider .slide.current img').click(function(e){
                e.stopPropagation();
              });
            }
          }, 200);
        }
      });
    },

    rotators: function() {
      this.$rotator.addClass('flexslider').flexslider({
        controlNav: true,
        directionNav: false,
        // -- Comment out Controls Container if
        // -- you intend to use controlNav
        controlsContainer: '.flex-direction-nav-container'
      });
    },

    overrides: function() {
      $(window).load(function() {
        setTimeout(function() {
          var i = 1;
          // - Betterbot
          $('img[src="https://dashboard.betterbot.ai/embed/images/close.png"]').attr('alt','betterbot close icon');
          $('img.betterbot_chat-btn').attr('alt','betterbot icon');
          // - Google recaptcha
          $("#g-recaptcha-response").attr({
            'aria-hidden': 'true',
            'aria-label': 'do not use',
            'aria-readonly': 'true'
          }).before('<label for="g-recaptcha-response" class="sr-only">reCaptcha</label>');
          $('.grecaptcha-logo iframe').attr('title','reCaptcha');
          // - Hy.ly
          $('#hy-frame-container').attr('title','Hy.ly Schedule A Tour');
          // - Date Picker
          $('.picker__day').removeAttr('aria-activedescendant');
          // - all iframes
          $('iframe').each(function(index) {
            if (!$(this).attr('title')) {
              $(this).attr('title', 'Embed ' + (++index));
            }
            $(this).removeAttr('frameborder').removeAttr('scrolling').removeAttr('width').removeAttr('height');
          });
          // - Google Map
          $('.gm-style img').each(function() {
            if (!$(this).attr('alt')) {
              $(this).attr('alt','Google Maps Icon ' + (++i));
            }
          });
        }, 500);
      });
    },

    popdownOverride: function() {
      if (typeof JonahPopdown != 'undefined') {
        JonahPopdown.on('beforeOpen', function(){
          $('#header').css('cssText', 'display:'+$('#header').css('display')+';position: absolute !important;');
        });

        JonahPopdown.on('load', function(){
          $('html').removeClass('cloak-header');

          $(window).on('load scroll', function(e){
            var offset = $(window).scrollTop();

            if (JonahPopdown.isOpen()) {
              offset = offset - JonahPopdown.el('popdown').outerHeight();
            }

            if (offset >= 0) {
              $('#header').css('position', '');
            } else {
              $('#header').css('cssText', 'display:'+$('#header').css('display')+';position: absolute !important;');
            }
          });
        });
      }
    },

    findYourHome: function() {
      var self = this;
      var contWidth = self.$findHomeContainer.outerWidth();
      var closeWidth = contWidth;
      self.$findHomeContainer.css('right', -contWidth);

      function setWidths() {
        if ($(window).width() <= siteSettings.breakpoints.fluid_medium) {
          contWidth = self.$findHomeContainer.outerWidth();
          closeWidth = '-100%';
        }
        else {
          contWidth = self.$findHomeContainer.outerWidth();
          closeWidth = -contWidth;
        }
      }

      $(window).on('load resize', function() {
        setWidths();

        if (!self.$findHome.is(':visible')) {
          self.$findHomeContainer.css('right', closeWidth);
        }
      });

      this.$findYourHome.click(function(e) {
        e.preventDefault();

        if (self.$findHome.is(':visible')) {
          self.$html.removeClass('find-open');
          self.$findHomeContainer.animate({
            right: closeWidth
          }, function() {
            self.$findHome.fadeOut();
          });
        }
        else {
          self.$html.addClass('find-open');
          self.$findHome.fadeIn(function() {
            self.$findHomeContainer.animate({
              right: 0
            });
          });
        }
      });
    },

    init: function() {
      this.domCache();
      this.mobileNav();
      this.header();
      this.sidebar();
      this.pagination();
      this.filter();
      this.petPolicy();
      this.lightbox();
      this.lazyLoad();
      this.rotators();
      this.overrides();
      this.popdownOverride();
      this.findYourHome();
    }
  };

  $(document).ready(function(){
    init.init();
  });

})(jQuery);

var markerIds = [];

(function($) {
  'use strict';

  if (typeof mapSettings != 'undefined') {
    var map = {
      dom: function () {
        this.$map = $('#map_canvas');
        this.$zoomIn = $('#zoom_in');
        this.$zoomOut = $('#zoom_out');
        this.$refresh = $('#refresh');
        this.$markerFilter = $('[data-js-hook="marker-filter"]');
        this.$infoBoxTemplate = $('#infobox-template');
        this.communityToggleBox = $('[data-js-hook="toggle-communty-infobox"]');
        this.$categorySelect = $('select[name="property_type"]');
        this.$propertyButton = $('[data-js-community]');

        this.$filterForm = $('#property-filter-form');
        this.$filterLoading = $('#property-filter-loading');
        this.$filterSelect = $('[data-js-hook="property-filter-select"]');
        this.$filterInput = $('#property-filter-input');
        this.$filterClear = $('#property-filter-clear');
        this.$filterClearAll = $('#property-filter-clear-all');
        this.$filterToggle = $('#property-filter-toggle');
        this.$noResults = $('#property-no-results');
      },

      definitions: function () {
        this.map;
        this.bounds;
        this.newZoom;
        this.newCenter;
        this.currentCategory;
        this.propertyData;
        this.icons = {};
        this.markers = [];
        this.aMarkers = [];
        this.aClusters = [];
        this.filtersArray = [];
        this.categories = [];
        this.assetPath = config.siteUrl + mapSettings.assetPath.replace(/^\/|\/$/g, '') + '/';

        // Editable
        this.zoomIncrement = 1;
        this.markerInfoboxHTML = this.$infoBoxTemplate.html();
        this.mapStyles = [
          {
            "featureType": "all",
            "elementType": "labels.text.fill",
            "stylers": [{
              "color": "#4a4a4a"
            }]
          }, {
            "featureType": "administrative.neighborhood",
            "elementType": "labels.text.fill",
            "stylers": [{
              "color": "#4a4a4a"
            }]
          }, {
            "featureType": "landscape",
            "elementType": "geometry.fill",
            "stylers": [{
              "color": "#e7e7e7"
            }]
          }, {
            "featureType": "landscape.man_made",
            "elementType": "labels",
            "stylers": [{
              "visibility": "off"
            }]
          }, {
            "featureType": "poi",
            "elementType": "all",
            "stylers": [{
              "visibility": "off"
            }]
          }, {
            "featureType": "poi.park",
            "elementType": "geometry.fill",
            "stylers": [{
              "color": "#dddddd"
            }, {
              "visibility": "on"
            }]
          }, {
            "featureType": "poi.park",
            "elementType": "labels.text",
            "stylers": [{
              "visibility": "on"
            }]
          }, {
            "featureType": "road",
            "elementType": "geometry.fill",
            "stylers": [{
              "color": "#ffffff"
            }]
          }, {
            "featureType": "road",
            "elementType": "geometry.stroke",
            "stylers": [{
              "visibility": "off"
            }]
          }, {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [{
              "color": "#b5b5b5"
            }]
          }, {
            "featureType": "transit",
            "elementType": "all",
            "stylers": [{
              "visibility": "off"
            }]
          }, {
            "featureType": "water",
            "elementType": "geometry.fill",
            "stylers": [{
              "color": "#a3b9c7"
            }]
          }, {
            "featureType": "water",
            "elementType": "labels.text",
            "stylers": [{
              "color": "#ffffff"
            }]
          }];
      },

      getData: function () {
        map.propertyData = mapSettings.cacheData.properties;
        map.categories = mapSettings.cacheData.categories;
      },

      onGoogleLoad: function (callback) {
        google.charts.load('current', {'packages': ['map']});
        google.charts.setOnLoadCallback(callback);
      },

      //  Build the map
      // ------------------------------------------------------------------
      loadMap: function () {
        map.setOptions();
        map.bounds = new google.maps.LatLngBounds();
        map.map = new google.maps.Map(map.$map[0], map.mapOptions);
        map.bindControls();
        map.bindFiltersActions();

        // Create Marker Categories (for grouping markers)
        map.createMarkerClusters(map.categories);

        // Draw markers on map
        var markerIndex = 0;
        $.each(map.propertyData, function (property_id, point) {
          map.drawMarkers(point);
          markerIds[property_id] = markerIndex++;
        });


        if (typeof filteredPropertyIds != 'undefined' && filteredPropertyIds.length) {
          map.markerVisibility();
        }

        map.setupMap();

        google.maps.event.addDomListener(map.map, 'resize', map.mapResize);

        google.maps.event.addDomListener(map.map, 'center_changed', function () {
          map.newCenter = map.map.getCenter();
        });
      },

      setupMap: function () {
        map.clusterMarkers();
        map.map.fitBounds(map.bounds);
        map.newCenter = map.map.getCenter();
      },


      //  Create marker clusters
      // ------------------------------------------------------------------
      createMarkerClusters: function (array) {
        $.each(array, function (index, object) {
          map.aMarkers[object.id] = {
            color: object.color,
            markers: []
          };
        });
      },


      //  Draw Markers on map
      // ------------------------------------------------------------------
      drawMarkers: function (point) {
        var self = this;

        // Make sure point has latitude & longitude otherwise there will be
        // a random marker in the middle of the Atlantic
        if (point.lat.length && point.lng.length) {
          var markerInfoboxHTML = map.markerInfoboxHTML.replace(/\n/g, '');
          var markerOptions = map.markerOptions;

          // -- Parse If Statements
          var ifStatement;
          if (ifStatement = /(\{\{if(.*?)\}\}(.*?)\{\{endif\}\})/g.exec(markerInfoboxHTML)) {
            var condition = ifStatement[2].trim();

            if (point[condition]) {
              markerInfoboxHTML = markerInfoboxHTML.replace(ifStatement[1], ifStatement[3]);
            } else {
              markerInfoboxHTML = markerInfoboxHTML.replace(ifStatement[1], '');
            }
          }

          //  Mustache replace
          // ------------------------------------------------------------------
          // -- Category Info
          for (var property in map.categories[point.property_type]) {
            if (property.length) {
              var expression = new RegExp('({{category_' + property + '}})', 'g');
              if (markerInfoboxHTML.match(expression)) {
                markerInfoboxHTML = markerInfoboxHTML.replace(expression, map.categories[point.property_type][property]);
              }
            }
          }
          // -- Property Info
          for (var property in point) {
            if (property.length) {
              var expression = new RegExp('({{' + property + '}})', 'g');
              if (markerInfoboxHTML.match(expression)) {
                markerInfoboxHTML = markerInfoboxHTML.replace(expression, point[property]);
              }
            }
          }

          var markerIcon = map.categories[point.property_type].svg_small;

          // -- Determine icon file extension. (.png if IE, .svg if not)
          if (navigator.userAgent.indexOf('rv:11') > -1 || navigator.userAgent.indexOf('MSIE') > -1) {
            markerIcon = map.categories[point.property_type].png;
          } else if (self.icons[point.property_type]) {
            markerIcon = self.icons[point.property_type];
          }

          var marker = new google.maps.Marker({
            map: map.map,
            position: new google.maps.LatLng(point.lat, point.lng),
            icon: markerIcon,
            title: point.name,
            zIndex: 2
          });

          $.extend(marker, {
            id: point.id,
            name: point.name,
            state: point.state,
            city: point.city,
            zip: point.zip,
            bed: point.bed,
            bath: point.bath,
            color: map.categories[point.property_type].color,
            query: point.query,
            property_id: point.property_id
          });

          // Add marker to marker group (used for clustering)
          map.aMarkers[point.property_type].markers.push(marker);
          map.markers.push(marker);

          // Add this marker to the map bounds (auto zoom to fit all markers)
          map.bounds.extend(marker.getPosition());

          $.extend(markerOptions, {
            content: markerInfoboxHTML
          });

          this.bindMarkerOpen(new InfoBox(markerOptions), marker);
        }
      },


      //  Cluster markers into groups using categories
      // ------------------------------------------------------------------
      clusterMarkers: function () {
        $.each(map.aClusters, function (index, group) {
          if (typeof group != 'undefined') {
            group.setMap(null);
          }
        });

        if (mapSettings.clusterMarkers) {
          $.each(map.aMarkers, function (index, markerCluster) {
            if (typeof markerCluster != 'undefined') {
              map.aClusters[index] = new MarkerClusterer(map.map, markerCluster.markers, map.clusterOptions(index, markerCluster.color));
              map.aClusters[index].setIgnoreHidden(true);
              map.aClusters[index].repaint();
            }
          });
        }
      },


      //  Toggle Marker Visibility
      // ------------------------------------------------------------------
      markerVisibility: function () {

        var markerCount = 0;

        // -- RESET map bounds
        map.bounds = new google.maps.LatLngBounds();

        // -- Close all InfoBoxes except Main
        if (map.openWindow && !map.openWindow.isMain) {
          map.openWindow.close();
        }

        //  Hide everything not matching passed-in filters
        // ------------------------------------------------------------------
        // -- Hide all markers of filter
        var showMarkers = filteredPropertyIds.length ? false : true;

        map.aMarkers.forEach(function (markerCluster) {
          // -- Remove markers from map
          $.each(markerCluster.markers, function (index, marker) {
            marker.setVisible(showMarkers);
          });
        });

        map.aMarkers.forEach(function (markerCluster) {
          $.each(markerCluster.markers, function (index, marker) {
            if ($.inArray(marker.property_id, filteredPropertyIds) == -1) {
              return;
            }

            map.bounds.extend(marker.position);
            marker.setVisible(true);
            markerCount++;
          });
        });

        if (markerCount === 0) {
          map.$noResults.fadeIn();
        } else {
          map.$noResults.fadeOut();
        }

        // -- Add markers to markerClusterer
        map.clusterMarkers();
        map.map.fitBounds(map.bounds);
      },


      //  Things to do after resizing map
      // ------------------------------------------------------------------
      mapResize: function () {
        setTimeout(function () {
          if (!map.newZoom) {
            map.map.fitBounds(map.bounds);
          }
          map.map.setCenter(map.newCenter);
        }, 500);
      },

      //  Open Marker Infobox
      // ------------------------------------------------------------------
      openMarker: function (infoBoxObject, markerObject) {
        // -- Close all InfoBoxes
        if (this.openWindow) {
          this.openWindow.close();
        }

        // -- Open new InfoBox
        infoBoxObject.open(map.map, markerObject);
        this.openWindow = infoBoxObject;
      },


      // ----------------------------------------------------------------------------
      //  BIND STUFF
      // ----------------------------------------------------------------------------
      //  Map Controls
      // ------------------------------------------------------------------
      bindControls: function () {
        map.$markerFilter.click(function (e) {
          e.preventDefault();
          map.$categorySelect.val($(this).data('category'));
          map.$categorySelect.trigger('change');
        });

        map.$propertyButton.click(function (e) {
          e.preventDefault();
          // show clear filter link
          map.$filterClearAll.show();

          // active card
          map.$propertyButton.closest('.community__listing-item').removeClass('active');
          $(this).closest('.community__listing-item').addClass('active');

          // scroll to map
          $('html').animate({scrollTop: Math.round($('#map_canvas').offset().top - ($('#header').height() + ($(window).width() > 808 ? 20 : 0)) ) });

          // now lets interact with the map
          var property_id = $(this).data('js-community');
          var marker_index = markerIds[property_id];

          // hide all markers
          map.aMarkers.forEach(function (markerCluster) {
            // -- Remove markers from map
            $.each(markerCluster.markers, function (index, marker) {
              marker.setVisible(false);
            });
          });

          // show the single property
          map.aMarkers.forEach(function (markerCluster) {
            $.each(markerCluster.markers, function (index, marker) {
              if (marker.property_id != property_id) {
                return;
              }

              map.bounds.extend(marker.position);
              marker.setVisible(true);
            });
          });

          // open the info box for property marker
          google.maps.event.trigger(map.markers[marker_index], 'click');
        });

        // -- Map click closes all windows
        google.maps.event.addListener(map.map, 'click', function (event) {
          if (map.openWindow) {
            map.openWindow.close();
          }
        });

        // -- Zoom In Control
        map.$zoomIn.unbind().click(function (e) {
          e.preventDefault();
          map.newZoom = map.map.getZoom() + map.zoomIncrement;
          map.map.setZoom(map.newZoom);
          map.newCenter = map.map.getCenter();
        });

        // -- Zoom Out Control
        map.$zoomOut.unbind().click(function (e) {
          e.preventDefault();
          map.newZoom = map.map.getZoom() - map.zoomIncrement;
          map.map.setZoom(map.newZoom);
          map.newCenter = map.map.getCenter();
        });

        // -- Refresh Control
        map.$refresh.unbind().click(function (e) {
          e.preventDefault();
          map.$propertyButton.closest('.community__listing-item').removeClass('active');
          map.$filterClearAll.trigger('click');
        });
      },


      //  Filters
      // ------------------------------------------------------------------
      bindFiltersActions: function () {
        map.$filterForm.on('submit', function () {
          map.markerVisibility();
        });
      },


      //  Map marker clickity click
      // ------------------------------------------------------------------
      bindMarkerOpen: function (infoBoxObject, markerObject) {
        google.maps.event.addListener(markerObject, 'click', function () {
          if (map.openWindow) {
            map.openWindow.close();
          }
          map.openMarker(infoBoxObject, markerObject);
        });
      },

      // ----------------------------------------------------------------------------
      //  OPTIONS
      // ----------------------------------------------------------------------------
      //  MarkerClusterer Options
      // ------------------------------------------------------------------
      clusterOptions: function (index, color) {
        return {
          gridSize: 20,
          maxZoom: 15,
          styles: [
            {
              url: 'data:image/svg+xml;charset=utf8,%3Csvg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="%23' + color + '"%3E%3Cpath d="M15,30A15,15,0,1,1,30,15,15,15,0,0,1,15,30ZM15,1.2A13.8,13.8,0,1,0,28.8,15,13.81,13.81,0,0,0,15,1.2Z"/%3E%3Ccircle cx="15" cy="15" r="10.8"/%3E%3C/svg%3E',
              height: 45,
              width: 45,
              anchor: [0, 0],
              textColor: '#fff',
              textSize: 16,
              iconAnchor: [0, 0]
            }
          ]
        };
      },


      //  Options for all other map elements
      // ------------------------------------------------------------------
      setOptions: function () {

        // -- Marker Infobox Options Object
        this.markerOptions = {
          content: null, // -- Set by drawPoint
          disableAutoPan: false,
          alignBottom: true,
          maxWidth: 0,
          pixelOffset: new google.maps.Size(-30, -44),
          zIndex: null,
          boxClass: 'communities-map__infobox',
          infoBoxClearance: new google.maps.Size(10, 10),
          isHidden: false,
          pane: 'floatPane',
          enableEventPropagation: false
        };

        // -- Map Options Object
        this.mapOptions = {
          // zoom: 14,
          minZoom: 2,
          maxZoom: 18,
          scrollwheel: false,
          center: map.latlng,
          mapTypeId: google.maps.MapTypeId.ROADMAP,
          mapTypeControl: false,
          disableDefaultUI: true,
          styles: map.mapStyles
        };
      },

      constructMapIcons: function () {
        var self = this;
        var $icons = $('[id^=poi_icon]');

        $icons.each(function () {
          $(this).find('circle').first().css({
            fill: $(this).data('fill')
          });

          var data;
          var xml = new XMLSerializer().serializeToString($(this).find('svg')[0]);

          if (window.btoa) {
            data = "data:image/svg+xml;base64," + btoa(xml);
          } else {
            data = "data:image/svg+xml;base64," + encode64(xml);
          }

          self.icons[$(this).data('category')] = data;
        });
      },

      checkData: function () {
        var self = this;
        // -- Keep on looping until the google maps script is loaded
        var mapLoaded = setInterval(function () {
          self.loopNum++;
          if (typeof InfoBox == 'function' && typeof google === 'object' && typeof google.maps === 'object') {
            clearInterval(mapLoaded);
            map.dom();
            map.definitions();
            map.getData();
            map.constructMapIcons();
            map.onGoogleLoad(map.loadMap);
          } else if (self.loopNum >= 10) {
            clearInterval(mapLoaded);
            $('.map__canvas-wrap').remove();
            return false;
          }
        }, 1000);
      },

      //  Do all the stuffs
      // ------------------------------------------------------------------
      ready: function () {
        setTimeout(function () {
          getCachedScript('//www.gstatic.com/charts/loader.js');
          getCachedScript('//maps.google.com/maps/api/js?v=quarterly&key=' + config.googleApiKey);
        }, 1200);
        map.checkData();
      }
    };

    $(function () {
      map.ready();
    });

  }

})(jQuery);

(function($){
  'use strict';

  var modal = {
    dom: function() {
      this.$modalToggle = $('[data-toggle="modal"]');
      this.$modal = $('[data-js-hook="modal"]');
      this.$close = $('[data-dismiss="modal"]');
    },

    showHideModal: function() {
      var self = this;

      this.$modalToggle.click(function(e) {
        e.preventDefault();
        var target = $(this).data('target');
        var embed = $(target).find('.modal__iframe-wrap');
        if ($(target).is(':visible')) {
          $(target).fadeOut();
          $('html').css('overflow','');
        }
        else {
          if (embed.length) {
            embed.append(decodeURIComponent(embed.data('embed-code')));
            setTimeout(function() {
              $('.modal__loading', $(target)).fadeOut();
            }, 2000);
          }
          else {
            $('.modal__loading', $(target)).fadeOut();
          }
          self.$modal.fadeOut();
          $(target).fadeIn();
          $('html').css('overflow','hidden');
        }
      });
    },

    closeModal: function() {
      this.$close.click(function(e) {
        e.preventDefault();
        var $target = $(this).closest('.modal');
        $target.fadeOut();
        $('html').css('overflow','');
      });
    },

    ready: function() {
      this.dom();
      this.showHideModal();
      this.closeModal();
    }
  };

  $(function() { modal.ready(); });

})(jQuery);

(function($){
  'use strict';

  if ($('html').hasClass('page-news')) {

    var news = {
      filterDom: function() {
        if ($(window).width() > 808) {
          $('.filter').prependTo('#page');
        }
        else {
          $('.filter').insertBefore('#filter-results-container');
        }
      },

      setHeight: function() {
        if ($(window).width() > 808) {
          var setHeight = 0;
          $('.article__item').each(function(){
            $(this).height('auto');
            if ($(this).height() > setHeight) {
              setHeight = $(this).height();
            }
          });
          $('.article__item').each(function(){
            $(this).height(setHeight);
          });
        }
        else {
          $('.article__item').each(function(){
            $(this).height('auto');
          });
        }
      },

      init: function() {
        this.setHeight();
        this.filterDom();
      }
    };

    $(window).on('load resize', function() {
      news.init();
    });

  }

})(jQuery);

(function($){
  'use strict';

  if ($('html').hasClass('page-resident-portal')) {

    var residents = {
      dom: function() {
        this.$residentSelect = $('#residentSelect');
      },

      residentSelect: function() {
        var self = this;

        this.$residentSelect.on('submit', function(e) {
          e.preventDefault();
          if ($('#resident-select').val() != '') {
            window.open($('#resident-select').val(), '_blank');
          }
        });
      },

      ready: function() {
        this.dom();
        this.residentSelect();
      }
    };

    $(function() { residents.ready(); });
  }

})(jQuery);

(function($) {
  'use strict';

  var shareThis = {
    dom: function() {
      this.shareContainer = $('#share-this-popup');
      this.shareLink = $('#share-link');
      this.shareLoader = $('#share-loader');
    },

    settings: function() {
      this.activeClass = 'share-this-popup--show';
    },

    setupShareThis: function() {
      var self = this;

      this.shareContainer.data('loaded', '0');

      this.shareLink.on('click',function(e) {
        e.preventDefault();
        e.stopPropagation();

        //If we don't have any Share This content on the page already, fetch it via AJAX
        if (self.shareContainer.data('loaded') == '0') {
          //indicate that it's loading...
          self.shareLoader.show();
          self.shareLink.css('opacity', 0);

          //mark Share This as loaded so we won't load it via AJAX again unless page is refreshed
          self.shareContainer.data('loaded', '1');

          //If user overrode defaults in the HTML markup, use the override values here
          var sUrl = self.shareContainer.data('url') || '';
          var sTweetFilter = self.shareContainer.data('tweet-filter') || 'GLOBAL';
          var sEmailFilter = self.shareContainer.data('email-filter') || 'GLOBAL';
          var iPropertyID = self.shareContainer.data('property') || '';

          //fetch the Share This content via AJAX
          self.shareContainer.load(self.shareContainer.data('script'), { 'url': sUrl, 'email_filter': sEmailFilter, 'tweet_filter': sTweetFilter, 'property': iPropertyID }, function() {
            self.shareContainer.addClass(self.activeClass);
            //remove the loading indicator
            self.shareLoader.hide();
            self.shareLink.css('opacity', 1);
          });
        }
        else {
          //We've already fetched Share This content for this page, so just show it
          self.shareContainer.toggleClass(self.activeClass);
        }
      });

      $('body').click(function() {
        //if the "SHARE" tooltip is visible, then close it
        if (self.shareContainer.hasClass(self.activeClass)) {
          self.shareContainer.toggleClass(self.activeClass);
        }
      });
    },

    ready: function() {
      this.dom();
      this.settings();
      this.setupShareThis();
    }
  };

  $(function() { shareThis.ready(); });

})(jQuery);

(function($){
  'use strict';

  if ($('html').hasClass('page-staff')) {

    var staff = {
      dom: function() {
        this.$staffFilter  = $('#departmentSelect');
        this.$filterSelect = $('#department-select');
        this.$department   = $('[data-js-hook="department"]');
        this.$staff        = $('[data-js-hook="staffMember"]');
        this.$staffContent = $('#staffContent');
        this.$staffLoader  = $('.staff__loading');
        this.$loader       = $('.modal__loader');
      },

      departmentSelect: function() {
        var self = this;

        this.$filterSelect.on('change', function() {
          self.$staffFilter.submit();
        });

        this.$staffFilter.on('submit', function(e) {
          e.preventDefault();
          self.$staffLoader.fadeIn(100);
          var id = self.$filterSelect.val();
          if (id != '') {
            $('.page__select-reset').show();
            self.$department.hide();
            $('[data-id="group' + id + '"]').show();
          }
          else {
            $('.page__select-reset').hide();
            self.$department.show();
          }

          $('.wow').css({
            'visibility' : 'visible',
            'animation-name' : 'none'
          }).removeClass('wow fadeInUp');
          setTimeout(function() {
            self.$staffLoader.fadeOut(200);
          }, 500);
        });

        $('.page__select-reset').click(function() {
          self.$staffFilter.find('select, input, textarea').val('');
          self.$staffFilter.submit();
        });
      },

      staffModal: function() {
        var self = this;

        this.$staff.click(function(e) {
          e.preventDefault();

          var target = $(this).attr('href');
          if (target.length) {
            self.$staffContent.load(target, function() {
              self.$staffContent.scrollTop(0);
              self.$loader.hide();
            });
          }
        });
      },

      ready: function() {
        this.dom();
        this.departmentSelect();
        this.staffModal();
      }
    };

    $(function() { staff.ready(); });
  }

})(jQuery);

(function($) {
  'use strict';

  if ($('html').hasClass('page-what-we-do')) {

    var whatWeDo = {
      domCache: function() {
        this.$expandDesc = $('[data-js-hook="expand-desc"]');
        this.$fullDesc = $('#expand-desc_' + this.$expandDesc.attr('data-id'));
      },

      expandDesc: function() {
        this.$expandDesc.on('click', function(e){
          e.preventDefault();
          var dataId = $(this).data('id');
          $('#expand-desc_' + dataId).toggle();
          $(this).text($(this).text() == '... Read More' ? '... Less' : '... Read More');
        });
      },

      init: function() {
        this.domCache();
        this.expandDesc();
      }
    };

    $(function() {
      whatWeDo.init();
    });

  }

})(jQuery);

//# sourceMappingURL=custom.js.map
